import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../api/axios";
import useBrandingLogo from "../hooks/useBrandingLogo";
import "../styles/admin.css";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const logoUrl = useBrandingLogo();

  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    setError("");

    try {
      setSubmitting(true);

      const cleanEmail = String(email || "").trim().toLowerCase();

      const res = await api.post("/auth/forgot-password/request-otp", {
        email: cleanEmail,
      });

      setMsg(res?.data?.message || "Recovery OTP sent successfully.");

      // 🔥 AUTO REDIRECT SA VERIFY PAGE
      setTimeout(() => {
        navigate("/forgot-password/verify", {
          replace: true,
          state: { email: cleanEmail },
        });
      }, 800);
    } catch (err) {
      console.error("Forgot password error:", err?.response?.data?.message || err.message);

      setError(
        err?.response?.data?.message ||
          err?.response?.statusText ||
          err?.message ||
          "Failed to process request."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="admin-login-page">
      <section className="admin-forgot-shell">
        <div className="admin-forgot-card">
          <img
            src={logoUrl}
            alt="FleetX Logo"
            className="admin-forgot-logo"
          />

          <p className="admin-login-form__eyebrow">Password Recovery</p>

          <h1 className="admin-forgot-title">Forgot Password?</h1>

          <p className="admin-forgot-subtitle">
            Enter your admin email and we’ll send a recovery OTP to reset your password.
          </p>

          <form onSubmit={handleSubmit} className="admin-login-form">
            <label className="admin-login-label">Email Address</label>

            <div className="admin-login-inputWrap">
              <span className="admin-login-inputIcon">✉</span>

              <input
                className="admin-login-input"
                type="email"
                placeholder="admin@fleetx.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                required
              />
            </div>

            <button
              type="submit"
              className="admin-login-button"
              disabled={submitting}
            >
              {submitting ? "Sending..." : "Send Recovery OTP"}
            </button>
          </form>

          {msg ? <p className="admin-forgot-success">{msg}</p> : null}
          {error ? <p className="admin-login-error">{error}</p> : null}

          <Link to="/login" className="admin-forgot-back">
            ← Back to Login
          </Link>
        </div>
      </section>
    </main>
  );
}
